import { SnLonLatLike } from '@lib/geo/helpers';

import { IMapBaseOverlayOptions } from '../base-overlay-options';

export interface IBaseEsriMarkerOptions extends IMapBaseOverlayOptions {
  title?: string;
  lonLat?: SnLonLatLike;
}
